import React from "react";
import { PaymentSection } from "./PaymentSection";
import { useAppState } from "../../../Redux/ReduxHooks";
import { BookingDataOwnership, BookingStatus } from "../../../Services/BookingEntities";

/**
 * Decides whether to display the payment section based on the fare type. It only needs to be displayed if the user opted to convert the booking in to Fixed Price.
 */
export const MaybePaymentSection: React.FC = () => {

    const isFixedFareSelected = useAppState(state => state.PhoneToCnp.IsFixedFareSelected);
    const isPaymentConfirmed = useAppState(state => state.PhoneToCnp.IsPaymentConfirmed);
    const bookingDetails = useAppState(state => state.PhoneToCnp.Booking)!;

    if (!isFixedFareSelected) return null;
    if (isPaymentConfirmed) return null;
    if (bookingDetails.TrackingInfo.BookingStatusID >= BookingStatus.PickedUp) return null;

    // User's with read-only access (shared booking) can't view this section.
    if (bookingDetails.DataOwnership === BookingDataOwnership.ReadOnlyLink) return null;

    return (
        <PaymentSection />
    )
}